export function isTableData(data: any): data is TableData {
  return (
    Array.isArray(data) &&
    !!data.length &&
    typeof data[0] === "object" &&
    !!Object.entries(data[0]).length
  );
}

export type TableData = TableRowData[];

export type TableRowData = {
  [columnName: string]: string;
};

// Legacy: detection helpers below are only used by legacy report components
// (DataTableCell, ReportCardCell, PlayerHeader). Explorer DataGrid now uses
// column-name-based detection via getFilterContextMetricType().

export type ShotChartData = string;

export function isShotChartData(data: string): data is ShotChartData {
  try {
    const cleaned = data.replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": ');
    const parsed = JSON.parse(cleaned);
    const containsObjects = parsed.every((el: any) => typeof el === "object");
    return Array.isArray(parsed) && containsObjects;
  } catch (e) {
    return false;
  }
}

export type ShotDetailChartData = string;

export function isShotDetailData(data: string): data is ShotDetailChartData {
  try {
    const cleaned = data.replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": ');
    const parsed = JSON.parse(cleaned);
    if (!Array.isArray(parsed) || parsed.length === 0) return false;
    const first = parsed[0];
    // Rich format has boolean `made` field (true/false).
    // Legacy format has numeric `made` field (count).
    // This distinguishes them even when optional fields (shotType, contestLevel) are absent.
    return (
      typeof first === "object" &&
      "x" in first &&
      "y" in first &&
      "made" in first &&
      typeof first.made === "boolean"
    );
  } catch (e) {
    return false;
  }
}

export type ActionDetailChartData = string;

export function isActionDetailData(
  data: string,
): data is ActionDetailChartData {
  try {
    const cleaned = data.replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": ');
    const parsed = JSON.parse(cleaned);
    // Action detail is an object { actions: [...], shots: [...] }, not a flat array
    if (Array.isArray(parsed) || typeof parsed !== "object" || parsed === null)
      return false;
    if (!Array.isArray(parsed.actions) || parsed.actions.length === 0)
      return false;
    const first = parsed.actions[0];
    return (
      typeof first === "object" &&
      "actionType" in first &&
      "x" in first &&
      "y" in first
    );
  } catch (e) {
    return false;
  }
}

type VideoData = string;

export function isVideoData(data: string): data is VideoData {
  try {
    if (!data || data === "0" || data === "nan") return false;
    const parsed = JSON.parse(data);
    return parsed && Array.isArray(parsed.filters);
  } catch (e) {
    return false;
  }
}
